<div class="card custom-card-border h-100"  [ngStyle]="styling?.card?.bodyStyling">
    <div class="card-body p-b-0">
        <div [innerHTML]="infoCardDetails">
        </div>
    </div>
</div>


        
